<template>
  <div class="uploadImg">
    <Modal :visible.sync="dialogVisible" @cancel="closeView" :footer="null" width="60%" :zIndex="4002">
      <img width="100%" :src="dialogImageUrl" alt="图片异常">
    </Modal>
    <Modal :visible.sync="selectImgVisible" @cancel="closeImgList" title="选择服务器已存在图片" width="60%" :zIndex="4001">
      <template slot="footer">
        <el-button @click="closeImgList">关闭</el-button>
      </template>
      <div class="imgs">
        <div class="left imageList" id="imgListLeft">
          已选择图片&emsp;<b>{{fileList.length}}</b>/{{limit}}
          <div class="imgItem" v-for="(item, i ) in fileList" :key="i">
            <div class="mask">
              <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview(item)"></i>
              <i class="el-icon-remove icon" @click="removeFile(i)"></i>
            </div>
            <el-image class="img" :src="item.url" fit="fill"/>
          </div>
        </div>
        <div class="right imageList" id="imgListRight" v-infinite-scroll="loadImg"
            :infinite-scroll-distance="10"
            infinite-scroll-disabled="imgLoadingDisabled">
            <div class="imgItem" v-for="(item, i ) in imageList" :key="i">
              <div class="mask">
                <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview(item)"></i>
                <i class="el-icon-circle-plus icon" @click="addImage(item)"></i>
                <Popconfirm
                  title="确定要删除这个图片吗？"
                  @confirm="deleteImage(item, i)"
                  okText="确定"
                  v-if="pathType !== 'goods'"
                  cancelText="取消"
                  :overlayStyle="{zIndex: 4003}"
                >
                  <i class="el-icon-delete-solid icon"></i>
                </Popconfirm>
              </div>
              <el-image class="img" :src="item.url" fit="fill"/>
            </div>
        </div>
      </div>
    </Modal>
    <Upload
      class="uploadImageBody"
      :class="{ big: size === 'big' }"
      action="#"
      ref="uploading"
      @preview="handlePictureCardPreview"
      listType="picture-card"
      :fileList="fileList"
      :multiple="true"
      :disabled="disabled"
      @change="fileChange"
      :openFileDialogOnClick="false"
    >
      <Popover v-if="fileList.length < limit && !disabled" title="选择图片方式" trigger="click" v-model="popoverVisible" :overlayStyle="{zIndex: 4000}">
        <div class="imgPlus">
          <i class="el-icon-plus"></i>
          <div class="ant-upload-text">上传图片</div>
        </div>
        <div class="selectWay" slot="content">
          <Upload
            :multiple="multiple"
            action="#"
            :fileList="[]"
            @change="selectChange"
            >
            <el-button type="primary" size="small" plain>本地图片</el-button>
          </Upload>
          <el-button type="primary" size="small" plain @click="openImgList">线上图片</el-button>
        </div>
      </Popover>
    </Upload>
  </div>
</template>

<script>
import { Upload, Modal, Popover, Popconfirm } from 'ant-design-vue';
import { BasicService } from '../../service/core/basic.service';
import { ImageService } from '../../service/image.service';
import moment from 'moment';
import { Message } from 'element-ui';

  export default {
    name: 'uploadImg',
    components: { Upload, Modal, Popover, Popconfirm },
    model: {
      prop: 'fileList',
      event: 'change'
    },
    props: {
      size: {
        type: String,
        default: 'default', // default | big
      },
      limit: {
        type: Number,
        default: 4
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      fileList: {
        type: Array,
        default: () => [],
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      // @param {'goods' | 'article' | 'certificates' | 'brand' | 'user'} path_type,
      pathType: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        dialogVisible: false,
        selectImgVisible: false,
        dialogImageUrl: '',
        popoverVisible: false,
        imageList: [],
        imgLoadingDisabled: false,
        // file假数据
          // {
          //   uid: 'uid',      // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
          //   name: 'xx.png'   // 文件名
          //   status: 'done', // 状态有：uploading done error removed
          //   percent: 100, // 进度条
          //   response: '{"status": "success"}', // 服务端响应内容
          //   linkProps: '{"download": "image"}', // 下载链接额外的 HTML 属性
          // }
      }
    },
    mounted() {
    },
    methods: {
      async fileChange({ fileList }) {
        this.popoverVisible = false;
        for (let i = 0; i < fileList.length; i++) {
          if (!fileList[i].url) {
            fileList[i].status = 'uploading';
            fileList[i].percent = 10;
          }
        }
        this.$emit('change', fileList);
        for (let i = 0; i < fileList.length; i++) {
          if (!fileList[i].url && !fileList[i].uploading) {
            fileList[i].uploading = true;
            BasicService.uploadForUrl(fileList[i].originFileObj, this.pathType).then(url => {

              fileList[i].percent = 100;
              fileList[i].name = '图片异常';
              const timeOut = setTimeout(() => {
                fileList[i].url = url;
                fileList[i].status = 'done';
                clearTimeout(timeOut);
              }, 200);
            });
          }
        }
        this.$emit('change', fileList);
      },
      async selectChange({ fileList }) {
        if (fileList && fileList.length) {
          this.fileChange({ fileList: [...this.fileList, ...fileList].slice(0, this.limit) })
        }
      },
      addImage(data) {
        if (this.fileList.length >= this.limit) {
          Message.warning({message: '图片已达上限', customClass: 'messageClass'});
          return ;
        }
        const fileList = [
          ...this.fileList,
          {
            uid: moment().valueOf(),
            name: '图片异常',
            url: data.url,
            status: 'done',
          }
        ];
        this.$emit('change', fileList);
      },
      async openImgList() {
        await this.loadImg();
        this.selectImgVisible = true;
      },
      async loadImg() {
        this.imgLoadingDisabled = true;
        const { originalData } = await ImageService.getList(this.imageList.length, 20, this.pathType);
        this.imageList = [...this.imageList, ...originalData.list];
        this.imgLoadingDisabled = false;
      },
      beforeUpload() {
        return false;
      },
      async deleteImage(data, i) {
        await ImageService.deleteItem(data.id,)
        this.imageList.splice(i, 1);
        this.imageList = [...this.imageList];
      },
      removeFile(i) {
          this.fileList.splice(i, 1);
          this.$emit('change', this.fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.thumbUrl || file.url;
        this.dialogVisible = true;
      },
      closeView() {
        this.dialogVisible = false;
      },
      closeImgList() {
        this.imageList = [];
        this.selectImgVisible = false;
      }
    }
  }
</script>

<style lang="scss" scoped>

.uploadImageBody {
  display: inline-block;
}
.big {
  & /deep/ .ant-upload-list-item {
    height: 240px;
    width: 240px;
  }
  & /deep/ .ant-upload.ant-upload-select-picture-card {
    height: 240px;
    width: 240px;
  }
  & /deep/ .ant-upload-list-item-info > span {
    height: 100%;
  }
}
.imgPlus {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // width: 200px;
}

.selectWay {
  display: flex;
  align-items: center;
  width: 170px;
  justify-content: space-between;
}
.imgs {
  height: 500px;
  width: 100%;
  display: flex;
  .right {
    height: 480px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .left {
    width: 120px;
    flex-basis: 120px;
    min-width: 150px;
    height: 480px;
    overflow-y: auto;
    overflow-x: hidden;
    border-right: 1px solid rgb(177, 177, 177);
  }
}

.imgItem {
  margin: 10px 5px 0 10px;
  position: relative;
  height: 120px;
  width: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid transparent;
  box-sizing: content-box;
  float: left;
  .mask {
    opacity: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 2;
    color: #fff;
    background: rgba(0, 0, 0, 0.247);
    font-size: 32px;
    .icon {
      cursor: pointer;
      transition: 200ms;
      &:hover {
        color: rgb(128, 214, 253);
      }
    }

    .el-icon-delete-solid, .el-icon-remove {
      color: red;
      &:hover {
        color: red;
      }
    }
  }
  .img {
    height: 100%;
    width: 100%;
    outline: none;
    border: none;
  }
  &:hover {
    border-color: rgb(30, 184, 255);
    .mask {
      opacity: 1;
      transition: 250ms;

    }
  }
}
</style>